// extracted by mini-css-extract-plugin
export default {"title":"title--nXYNq","btn":"btn--d3HP2","alertModal":"alertModal--QLdVE"};